import React, { useEffect, lazy } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as loaderActions from "../../redux/loaderAction";
import * as toastComponentAction from "../../redux/toast-componentAction";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import admobSubscriptionService from "services/admobSubscription";
import Badge from "components/Badge/Badge.js";
import moment from "moment";

const ReactTable = lazy(() =>
  import(
    /* webpackChunkName: "react-table" */ "components/ReactTable/ReactTable.js"
  )
);

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
};

const useStyles = makeStyles(styles);

const getPlatformColor = (platform) => {
  switch (platform) {
    case "apple":
      return "info";
    case "google":
      return "success";
    case "stripe":
      return "warning";
    default:
      return "primary";
  }
};

const getPlatformLabel = (platform) => {
  switch (platform) {
    case "apple":
      return "Apple";
    case "google":
      return "Google";
    case "stripe":
      return "Stripe";
    default:
      return platform || "-";
  }
};

const AdmobSubscriptionContainer = (props) => {
  const [data, setData] = React.useState([]);
  const classes = useStyles();

  useEffect(() => {
    (async () => {
      const response = await admobSubscriptionService.subscriptionList();
      if (response && response.data) {
        setData(
          response.data.map((prop, key) => {
            const isActive =
              prop.is_subscribe === 1 &&
              (!prop.subscription_ends_at ||
                new Date(prop.subscription_ends_at) > new Date());

            return {
              id: key + 1,
              user: (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    columnGap: "10px",
                  }}
                >
                  <img
                    src={prop.profile_photo_url}
                    alt="profile"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                  <div>
                    <p style={{ margin: 0, fontWeight: "bold" }}>
                      {prop.name || "-"}
                    </p>
                    <p style={{ margin: 0, fontSize: "12px", color: "#aaa" }}>
                      @{prop.username}
                    </p>
                  </div>
                </div>
              ),
              email: prop.email || "-",
              platform: (
                <div style={{ textAlign: "center" }}>
                  <Badge color={getPlatformColor(prop.subscription_platform)}>
                    {getPlatformLabel(prop.subscription_platform)}
                  </Badge>
                </div>
              ),
              expires_at: prop.subscription_ends_at ? (
                <div style={{ textAlign: "center" }}>
                  {moment(prop.subscription_ends_at).format("DD/MM/YYYY HH:mm")}
                </div>
              ) : (
                <div style={{ textAlign: "center" }}>-</div>
              ),
              status: (
                <div style={{ textAlign: "center" }}>
                  <Badge color={isActive ? "success" : "danger"}>
                    {isActive ? "Active" : "Expired"}
                  </Badge>
                </div>
              ),
            };
          })
        );
      }
    })();
  }, []);

  return (
    <>
      <GridContainer justify="space-between" container>
        <GridItem></GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardHeader color="primary" icon>
              <CardIcon color="primary">
                <Assignment />
              </CardIcon>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <h4 className={classes.cardIconTitle}>
                  AdMob Subscriptions
                </h4>
              </div>
            </CardHeader>
            <CardBody>
              <ReactTable
                columns={[
                  {
                    Header: "#",
                    accessor: "id",
                    width: 60,
                  },
                  {
                    Header: "User",
                    accessor: "user",
                  },
                  {
                    Header: "Email",
                    accessor: "email",
                  },
                  {
                    Header: "Platform",
                    accessor: "platform",
                  },
                  {
                    Header: "Expires At",
                    accessor: "expires_at",
                  },
                  {
                    Header: "Status",
                    accessor: "status",
                  },
                  {
                    Header: "",
                    accessor: "as",
                  },
                ]}
                data={data}
              />
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  loaderActions: bindActionCreators(loaderActions, dispatch),
  toastComponentAction: bindActionCreators(toastComponentAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdmobSubscriptionContainer);
